import { Tag } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

type DeploymentAccess = {
  mode: 'public' | 'intranet';
};

type SetupStatus = { deploymentAccess?: DeploymentAccess };

export function DeploymentAccessBadge() {
  const { t } = useTranslation();
  const [deploymentAccess, setDeploymentAccess] = useState<
    DeploymentAccess | null | undefined
  >(null);

  useEffect(() => {
    let active = true;
    void fetch('/api/v1/system/setup/status')
      .then((response) => {
        if (!response.ok)
          throw new Error('Unable to load deployment access mode');
        return response.json() as Promise<SetupStatus>;
      })
      .then((status) => {
        if (active) setDeploymentAccess(status.deploymentAccess);
      })
      .catch(() => {
        if (active) setDeploymentAccess(undefined);
      });
    return () => {
      active = false;
    };
  }, []);

  const mode = deploymentAccess?.mode;
  const label = mode
    ? t(`shell.accessMode.${mode}`)
    : deploymentAccess === null
      ? t('shell.accessMode.loading')
      : t('shell.accessMode.unknown');
  const color =
    mode === 'public' ? 'orange' : mode === 'intranet' ? 'blue' : 'default';

  return (
    <Tag color={color} aria-live="polite">
      {label}
    </Tag>
  );
}
